import DuckEntity from './DuckEntity';
import { actionize, apiAction, apiFetch } from 'utils';

const duck = new DuckEntity('orders');

let types = {
  ON_COMPLETE_REDIRECT: null
};
types = actionize(types, (action) => `schooladmin/orders/${action}`);


const onCompleteRedirect = (order) => {
  // at some point we can use react-router-redux to do this, but for now we need to redirect to a non-react page, and react-router-redux doesn't do that.
  const payNowQParam = order.pay_now === true ? '?pay_now=true' : '';
  const redirectingToUrl = `/orders/${order.id}/completed_redir${payNowQParam}`;
  window.location = redirectingToUrl;

  return {
    type: types.ON_COMPLETE_REDIRECT,
    order,
    redirectingToUrl
  };
};

const updateRedirectingUrl = (state={}, action) => {
  if (action.type === types.ON_COMPLETE_REDIRECT) {
    return action.redirectingToUrl;
  }

  return state.redirectingToUrl;
};

const initialState = {
  ...duck.initialState,
  redirectingToUrl: null
};

const reducer = (state = initialState, action) => ({
  ...duck.reducer(state, action),
  redirectingToUrl: updateRedirectingUrl(state, action)
});

/**
 * Completes an asynchronous purchase.
 *
 * @param order the order
 * @param options payment gateway options
 */
const complete = (order, options = {}) => apiAction(
  duck.actions.SAVE_BEGIN,
  duck.actions.SAVE_SUCCESS,
  duck.actions.SAVE_ERROR,
  (state) => apiFetch.post(
    state,
    duck.config.entityApiPath(order.id) + '/complete',
    { order, options }
  ),
  {
    entityName: duck.config.name,
    create: false,
    update: true,
    id: order.id,
  },
  { [duck.config.jsonRoot]: duck.config.schema }
);

/**
 * Cancels an asynchronous purchase.
 *
 * @param order the order
 */
const cancel = (order) => apiAction(
  duck.actions.SAVE_BEGIN,
  duck.actions.SAVE_SUCCESS,
  duck.actions.SAVE_ERROR,
  (state) => apiFetch.post(
    state,
    duck.config.entityApiPath(order.id) + '/cancel',
    { order }
  ),
  {
    entityName: duck.config.name,
    create: false,
    update: true,
    id: order.id,
  },
  { [duck.config.jsonRoot]: duck.config.schema }
);

export default reducer;

export const entity = {
  ...duck,
  reducer,
  actions: {
    ...duck.actions,
    ...types,
    complete,
    cancel,
    onCompleteRedirect
  }
};
